define('lq/navigatorMpa',[
    'lq',
    './navigationHistory'
], function (lq, NavigationHistory) {
    'use strict';
    
    var NavigatorMpa = function (url, friendlyNames) {
        this.url = url;
        this.friendlyNames = friendlyNames;
        this.history = NavigationHistory.withLocalStorage('mpa');
    };

    NavigatorMpa.prototype.openAction = function (actionId, globals, locals, openBlank) {
        this.history.push(window.location.href);

        var route = this.friendlyNames[actionId];

        if (!route)
            route = 'LicquidAction/Get/' + actionId;

        var parameters = {};
        if (_.keys(globals).length)
            parameters.globals = JSON.stringify(globals);
        if (_.keys(locals).length)
            parameters.parameters = JSON.stringify(locals);

        var targetUrl = this.url.prepare(lq.getTenantUrl(route), parameters);
        this.url.openUrl(targetUrl, openBlank);
    };

    NavigatorMpa.prototype.navigationStarting = function () {
    };

    NavigatorMpa.prototype.getPreviousId = function () {
        return this.history.peek();
    };

    NavigatorMpa.prototype.goToPrevious = function (globals, locals) {
        var previousUrl = this.history.pop();
        if (!previousUrl) return;
        
        var parameters = {

            globals: globals
                ? JSON.stringify(globals)
                : undefined,

            parameters: locals
                ? JSON.stringify(locals)
                : undefined

        };
        var targetUrl = this.url.prepare(previousUrl, parameters);
        this.url.openUrl(targetUrl, false);
    };

    return NavigatorMpa;
});
